import { breakpoint } from '../utilities/breakpoint-setup'
import { Draggable } from "gsap/Draggable"

let navigationPosition = 0
let navigationWH = $('.years-menu').height()
let navigationContainerWH = $('.years-menu-scroll-c').height()
let navigationContainerWHHalf = $('.years-menu-scroll-c').height() / 2
let maxScrollPosition = navigationContainerWH - navigationWH
let year_element_wh = $('.years-menu-el').outerHeight() * 3


if(breakpoint('screen') < breakpoint('lg')) {

  navigationWH = $('.years-menu').width()
  navigationContainerWH = $('.years-menu-scroll-c').width()
  navigationContainerWHHalf = $('.years-menu-scroll-c').width() / 2
  year_element_wh = $('.years-menu-el').width() * 3

  maxScrollPosition = navigationContainerWH - navigationWH
}

function setupTimelineNavigation()
{
  if(!$('.years-menu-c').length) return

  let body = $('body')

  if(breakpoint('screen') < breakpoint('md')) {
    let right = $('.years-menu').width() - $('.years-menu-scroll-c').width()
    Draggable.create(".years-menu", {type:"x", edgeResistance:0.65, bounds: {minX:0, maxX:-1*right}, inertia:true});
  }


  body.on('click', '.years-top', function (e){
    scrollNavigation(year_element_wh)
  })

  body.on('click', '.years-bottom', function (e){
    scrollNavigation(year_element_wh * -1)
  })

}

function scrollNavigation(scrollPos)
{
  navigationPosition += scrollPos

  if(navigationPosition > 0) {
    navigationPosition = 0
  }

  if(navigationPosition < maxScrollPosition) {
    navigationPosition = maxScrollPosition
  }

  scrollToPosition(navigationPosition)
}

function scrollTimelineNavigation(canScroll)
{
  if(!canScroll || !$('.years-menu').length) return
  let scroll_to = 0

  let current_year = $('.years-menu-el.active')

  let current_year_top = current_year.offset().top - $('.years-menu').offset().top + 15
  if(breakpoint('screen') < breakpoint('lg')) {
    current_year_top = current_year.offset().left - $('.years-menu').offset().left + current_year.width()
  }

  if (current_year_top > navigationContainerWHHalf){
    scroll_to = -current_year_top + (navigationContainerWHHalf)
  }
  if(scroll_to < maxScrollPosition) {
    scroll_to = maxScrollPosition
  }

  scrollToPosition(scroll_to)

}

function scrollToPosition(position)
{

  if(navigationWH <= navigationContainerWH) {
    position = 0
  }

  if(breakpoint('screen') > breakpoint('lg')) {
    $('.years-menu').css('top', position + 'px');
  } else {
    $('.years-menu').css('left', position + 'px');
  }

}

export { setupTimelineNavigation, scrollNavigation, scrollTimelineNavigation }